import React, { Component } from "react";
import "./Banner.css";
import withRouter from "../withRouter/withRouter";
class Banner extends Component {
    constructor(props) {
        super(props);
    }
    state = {};

    render() {
        let { banners } = this.props;
        let i = 0,
            j = 0;
        return (
            <div
                id="carouselExampleCaptions"
                className="carousel slide Banner"
                data-bs-ride="false"
            >
                <div className="carousel-indicators">
                    {banners.map((b) => {
                        return (
                            <button
                                type="button"
                                data-bs-target="#carouselExampleCaptions"
                                data-bs-slide-to={i}
                                className={i == 0 ? "active" : ""}
                                aria-current="true"
                                aria-label={"Slide " + ++i}
                                key={i}
                            ></button>
                        );
                    })}
                </div>

                <div className="carousel-inner">
                    {banners.map((b) => {
                        return (
                            <a
                                className={
                                    "carousel-item " + (j == 0 ? "active" : "")
                                }
                                href={b.link}
                                key={++j}
                            >
                                <img src={b.image} className="d-block w-100" />
                                <div className="carousel-caption d-none d-md-block">
                                    <h5 className="label">{b.label}</h5>
                                    <p className="description">
                                        {b.description}
                                    </p>
                                </div>
                            </a>
                        );
                    })}
                </div>

                <button
                    className="carousel-control-prev"
                    type="button"
                    data-bs-target="#carouselExampleCaptions"
                    data-bs-slide="prev"
                >
                    <span
                        className="carousel-control-prev-icon"
                        aria-hidden="true"
                    ></span>
                    <span className="visually-hidden">Previous</span>
                </button>
                <button
                    className="carousel-control-next"
                    type="button"
                    data-bs-target="#carouselExampleCaptions"
                    data-bs-slide="next"
                >
                    <span
                        className="carousel-control-next-icon"
                        aria-hidden="true"
                    ></span>
                    <span className="visually-hidden">Next</span>
                </button>
            </div>
        );
    }
}

export default withRouter(Banner);
